<template>
  <Modal
    ref="modal"
    title="Confirm State Change"
  >
    <p
      v-if="error"
      class="text-danger"
    >
      {{ error }}
    </p>
    <label>Are you sure you want to '{{ transition.name }}'</label><br>
    <button
      class="btn btn-primary"
      @click.prevent="changeState"
    >
      Yes
    </button>
    <button
      class="btn btn-default"
      @click.prevent="cancel()"
    >
      No
    </button>
  </Modal>
</template>

<script>
/**
 * Dialog with Yes/No to confirm a project state change.
 * Emits a 'state-change' event with the new state when change is successful.
 */
import Modal from '@/components/Modal'
import projectAPI from '@/api/project'

export default {
  components: {
    Modal,
  },
  data () {
    return {
      projectId: '',
      transition: {},
      error: '',
    }
  },
  methods: {
    reset () {
      this.transition = {}
      this.error = ''
    },
    cancel () {
      this.$refs.modal.hide()
      this.reset()
    },
    changeState () {
      projectAPI.updateState(this.projectId, this.transition.dst_state).then(resp => {
        this.$emit('state-change', this.transition.dst_state)
        this.cancel()
      }).catch(error => {
        this.error = error.message
      })
    },
    /**
     * @description open modal to confirm state change
     * @param {Object} transitionName - state transition
     * @param {Object} projectID - project ID
     */
    toConfirm (transition, projectID) {
      this.reset()
      this.projectId = projectID
      this.transition = transition
      this.$refs.modal.show()
    },
  },
}
</script>
